import * as Styled from './PunchupRecipientInfoForm.styles';

import { PunchupInput } from 'features/common/components/Form/PunchupInput';
import { PunchupInputToggle } from 'features/common/components/Form/PunchupInputToggle/PunchupInputToggle';
import { PunchupQuantityCard } from '../PunchupQuantityCard/PunchupQuantityCard';
import { RecipientInfoFormProps } from './types';
import { useFormContext } from 'react-hook-form';

export const PunchupRecipientInfoForm = ({ id, ticketTypes, onRemove }: RecipientInfoFormProps) => {
	const currentRecipient = `recipients[${id}]`;
	const lastnameId = `${currentRecipient}.lastName`;
	const firstnameId = `${currentRecipient}.firstName`;
	const emailId = `${currentRecipient}.email`;
	const noEmailId = `${currentRecipient}.noEmail`;

	const { watch } = useFormContext();
	const noEmail = watch(noEmailId);

	return (
		<Styled.CardContainer>
			<Styled.Header justifyContent="space-between" alignItems="center">
				<Styled.RecipientName>Recipient {id + 1}</Styled.RecipientName>
				<Styled.Icon iconName="close" onClick={() => onRemove(id)} />
			</Styled.Header>

			<Styled.FieldsGroup>
				<Styled.WrapperInputs>
					<PunchupInput label="First Name" name={firstnameId} id={firstnameId} />
					<PunchupInput label="Last Name" name={lastnameId} id={lastnameId} />
				</Styled.WrapperInputs>

				{!noEmail && <PunchupInput label="Attendee Email" name={emailId} id={emailId} />}

				<PunchupInputToggle htmlFor={noEmailId} name={noEmailId} label="Recipient has no email" />
			</Styled.FieldsGroup>

			<Styled.Divider />

			<PunchupQuantityCard recipientId={id} ticketTypes={ticketTypes} />
		</Styled.CardContainer>
	);
};
